import { useStudentInvoicesQuery } from 'core';

export interface IStudentInvoice {
  fakturowniaId: string | null;
  number: string | null;
  status: string | null;
  issueDate: string | null;
  paymentTo: string | null;
  currency: string | null;
  priceGross: number | null;
  paid: number | null;
  outstanding: number | null;
  isOverdue: boolean | null;
  daysOverdue: number | null;
  viewUrl: string | null;
  paymentUrl: string | null;
  /** ТЗ 0044: у фактуры есть корректировка — суммы выше уже нетто. */
  isCorrected: boolean | null;
  correctionReason: string | null;
}

interface IUseMyInvoices {
  invoices: IStudentInvoice[];
  loading: boolean;
  error: string;
}

/**
 * Reads the logged-in student's own issued invoices (paid + unpaid) via the
 * `myInvoices` query. `cache-and-network` so a freshly issued/paid invoice
 * surfaces on the next mount without a hard reload. Returns a flat list — no
 * transform layer needed since the backend already shapes the row.
 */
export const useMyInvoices = (): IUseMyInvoices => {
  const { data, loading, error } = useStudentInvoicesQuery({
    fetchPolicy: 'cache-and-network',
  });

  return {
    invoices: (data?.myInvoices ?? []).filter(Boolean) as IStudentInvoice[],
    loading,
    error: error?.message || '',
  };
};
